import '@/assets/stylus/main.styl'
import 'babel-polyfill'
import 'url-search-params-polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import DatePicker from '@/components/DatePicker'
import DateInput from '@/components/DateInput'
import TimePicker from '@/components/TimePicker'

//csvupload 变更为table upload,支持csv,xls,xlsx
//import CSVUpload from '@/components/CSVUpload'
import TableUpload from '@/components/TableUpload'
import MultiTableUpload from '@/components/MultiTableUpload'
import RemoteSelect from '@/components/RemoteSelect'
import RemoteSelect1 from '@/components/RemoteSelect1'
import RemoteAutocomplete from '@/components/RemoteAutocomplete'
import QueryAutocomplete from '@/components/QueryAutocomplete'
import ListCharges from '@/components/ListCharges'
import EditCharges from '@/components/EditCharges'
import CommentInput from '@/components/CommentInput'
import ListSummaryCharges from '@/components/ListSummaryCharges'
import ListTotalCharges from '@/components/ListTotalChargesV2'
import Lookup from '@/components/Lookup'
import OutputDialog from '@/components/OutputDialog'
import OutputDialogSplit from '@/components/OutputDialogSplit'
import OutputDialogWithBtns from '@/components/OutputDialogWithBtns'
import FilePicker from '@/components/FilePicker'
import FileUpload from '@/components/FileUpload'
import TdocFileUpload from '@/components/TdocFileUpload'
import MessageAlert from '@/components/MessageAlert'
import FullMessageAlert from '@/components/FullMessageAlert'
import ConfirmDialog from '@/components/ConfirmDialog'
import LoadingMessage from '@/components/LoadingMessage'
import EmailBlank from '@/components/EmailBlank'
import axios from 'axios'
import FixedColumnWrap from '@/components/FixedColumnWrap'
import DateFormat from 'dateformat'

import VueI18n from 'vue-i18n'

import ExportTableFile from '@/service/ExportTableFile'
import ExportExcelFile from '@/service/ExportExcelFile'
import ErrorCatch from '@/service/ErrorCatch'

import TimeLine from '@/components/TimeLine'

import qs from 'qs'
import Api from '@/service/Api'
import { auth } from '@/assets/errors/auth'
import { InitUpload } from "@jusda-tools/jusda-file-upload";


import VueCurrencyFilter from 'vue-currency-filter'
import { initGlobalPoints } from '@jusda-tools/buried-point'
import { CookieTools, JUSDATOKEN } from '@jusda-tools/jusda-publicmethod';


Vue.use(VueCurrencyFilter, {
  symbol: '',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: true,
})
Vue.use(require('vue-moment'))
Vue.config.productionTip = false
Vue.prototype.$qs = qs
Vue.prototype.$pageable = function () {
  return {
    page: this.pagination.page - 1,
    size: this.pagination.rowsPerPage,
    sort: [
      this.pagination.sortBy,
      this.pagination.descending ? 'desc' : 'asc',
    ].join(','),
  }
}

Vue.prototype.$pagination = function (page) {
  Vue.set(this.pagination, 'content', page.content)
  Vue.set(this.pagination, 'page', page.number + 1)
  Vue.set(this.pagination, 'rowsPerPage', page.size)
  Vue.set(this.pagination, 'totalItems', page.totalElements)
}

Vue.component('date-picker', DatePicker)
Vue.component('date-input', DateInput)
Vue.component('time-picker', TimePicker)
Vue.component('remote-select', RemoteSelect)
Vue.component('remote-select1', RemoteSelect1)
Vue.component('remote-autocomplete', RemoteAutocomplete)
Vue.component('query-autocomplete', QueryAutocomplete)
Vue.component('output-dialog', OutputDialog)
Vue.component('output-dialog-with-btns', OutputDialogWithBtns)
Vue.component('output-dialog-split', OutputDialogSplit)
Vue.component('file-picker', FilePicker)
Vue.component('file-upload', FileUpload)
Vue.component('tdoc-file-upload', TdocFileUpload)
Vue.component('lookup', Lookup)
Vue.component('message-alert', MessageAlert)
Vue.component('full-message-alert', FullMessageAlert)
Vue.component('confirm-dialog', ConfirmDialog)

//系统中用的csvupload废弃掉，改为使用tableUpload,可以上传csv,xls,xlsx中任意一种格式
//Vue.component('csv-upload', CSVUpload)
Vue.component('table-upload', TableUpload)
Vue.component('multi-table-upload', MultiTableUpload)

Vue.component('loading-message', LoadingMessage)
Vue.component('list-charges', ListCharges)
Vue.component('edit-charges', EditCharges)
Vue.component('comment-input', CommentInput)
Vue.component('comment-input')
Vue.component('list-summary-charges', ListSummaryCharges)
Vue.component('list-total-charges', ListTotalCharges)
Vue.component('email-blank', EmailBlank)
Vue.component('time-line', TimeLine)
Vue.component('fixed-column-wrap', FixedColumnWrap)

//埋点
function buriedPoint(from, to) {
  if (!window.baseConfig) return
  const runtimeEnv = window.baseConfig.runtimeEnv
  const buriedPointUrl = window.baseConfig.userEventUrl
  var requestJson = {
    topic: 'juslink.user-event',
    data: {
      action: 'page-view',
      isProxy: false,
      isBusinessOperations: true,
      appName: 'SHARP',
      tenantName: 'SHARP SCM',
      tenantId: 4673304402397343745,
      time: new Date().getTime(),
      userName: store.getters.user && store.getters.user.fullName,
      accountName: store.getters.user && store.getters.user.userAccountId,
      runtimeEnv: runtimeEnv,
      userId: store.getters.user && store.getters.user.userAccountId,
      locationHash: from.path,
      properties: {
        from: from.path,
        to: to.path,
      },
    },
  }
  axios.post(buriedPointUrl, requestJson).then((res) => {
    console.log(res.data)
  })
}

router.beforeEach((to, from, next) => {
  if (store.getters.isLoggedIn) {
    buriedPoint(from, to)
  }
  if (to.path.indexOf('/reset-pwd') !== -1) {
    next()
    return
  }
  if (to.meta.permit && !Vue.prototype.$permit(to.meta.permit)) {
    Vue.prototype.$message('Alert', 'Not authorized to use this function')
    next(false)
    return
  }
  if (to.meta.public || store.getters.isLoggedIn) {
    next()
    return
  }

  next({
    path: '/b0100',
    query: {
      redirect: 'B0102',
    },
  })
})

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'jp',
  messages: {
    cn: require('./assets/lang/cn'),
    en: require('./assets/lang/en'),
    jp: require('./assets/lang/jp'),
  },
})

Vue.prototype.$buriedPoint1 = () => {
  var token = localStorage.getItem('access_token')
  if(!token){
    return
  }
  initGlobalPoints("SHARP",{token:token})
}

Vue.prototype.$bus = new Vue()
Vue.prototype.$message = (title, content, icon) => {
  Vue.prototype.$bus.$emit('message', {
    title: title,
    content: content,
    icon: icon,
  })
}
Vue.prototype.$fullMessage = (title, content) => {
  Vue.prototype.$bus.$emit('fullMessage', {
    title: title,
    content: content,
  })
}
Vue.prototype.$confirm = ({ title, content, action, rejectAction }) => {
  let p = new Promise((resolve, reject) => {
    Vue.prototype.$bus.$emit('confirm', {
      title: title,
      content: content,
      action: action,
      rejectAction: rejectAction,
      resolve: resolve,
      reject: reject,
    })
  })
  return p
}

Vue.prototype.$changeUI = (ui) => {
  Vue.prototype.$bus.$emit('changeUI', ui)
}

Vue.use(Api, {
  store,
  router,
})

store.commit('RELOAD')

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount('#app')

Date.prototype.format = function (format) {
  var o = {
    'M+': this.getMonth() + 1, //month
    'd+': this.getDate(), //day
    'h+': this.getHours(), //hour
    'm+': this.getMinutes(), //minute
    's+': this.getSeconds(), //second
    'q+': Math.floor((this.getMonth() + 3) / 3), //quarter
    S: this.getMilliseconds(), //millisecond
  }
  if (/(y+)/.test(format))
    format = format.replace(
      RegExp.$1,
      (this.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  for (var k in o)
    if (new RegExp('(' + k + ')').test(format))
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
  return format
}

Vue.prototype.$insert = function insertStr(source, start, end, newStr) {
  return source.slice(start, end) + newStr + source.slice(end)
}

Vue.use(ExportTableFile)
Vue.use(ExportExcelFile)
Vue.use(ErrorCatch)

Vue.filter('MCurrency', function (value) {
  if (!value || value == 'null') return ''
  value = value.toString()
  var arr = value.split(':')
  if (arr.length == 1 || arr.length > 3) return value

  let prefix = arr.length == 3 ? arr[1] + ' ' : ''
  let index = arr.length == 3 ? 2 : 1

  return prefix + parseFloat(arr[index]).toFixed(arr[0] === 'JPY' ? 0 : 2)
})

Vue.prototype.$hasLength = function (str) {
  return !!str && str.length > 0
}

Vue.prototype.$isAdmin = function () {
  var t = 'TangoTE' === this.$store.getters.user.code
  var f = 'jory' === this.$store.getters.user.code
  var a = 'AdminAlex' === this.$store.getters.user.code
  var alex = 'UAC_101134' === this.$store.getters.user.userAccountId
  var daniel = 'UAC_100473' === this.$store.getters.user.userAccountId
  return (
    alex === true || daniel === true || t === true || f === true || a === true
  )
}

Vue.prototype.$getCurrencyRate = (currency, scope, date) => {
  // console.log(currency.code, scope, date)
  if (currency.code === 'JPY') {
    return 1
  }
  let arr = currency.rates
    .filter((i) => i.scopeCode == scope)
    .filter((i) => {
      let startDate = i.startDate || '0000-00-00'
      return startDate.localeCompare(date) <= 0
    })
    .filter((i) => {
      let endDate = i.endDate || '9999-99-99'
      return endDate.localeCompare(date) >= 0
    })
  if (arr.length > 0) {
    // console.log('rate:', arr[0].rate)
    return arr[0].rate
  }
  // console.log('rate:', 0)
  return 0
}

Vue.prototype.$getNextDay = (dateTemp, days) => {
  var dateTemp = dateTemp.split('-')
  var nDate = new Date(dateTemp[1] + '-' + dateTemp[2] + '-' + dateTemp[0]) //转换为MM-DD-YYYY格式
  var millSeconds = Math.abs(nDate) + days * 24 * 60 * 60 * 1000
  var rDate = new Date(millSeconds)
  var year = rDate.getFullYear()
  var month = rDate.getMonth() + 1
  if (month < 10) month = '0' + month
  var date = rDate.getDate()
  if (date < 10) date = '0' + date
  return year + '-' + month + '-' + date
}

function numberDeal(number) {
  number = number + ''
  number = number.replace(/[^\d.]/g, '') //清除"数字"和"."以外的字符
  number = number.replace(/^\./g, '') //验证第一个字符是数字而不是.
  number = number.replace(/\.{2,}/g, '.') //只保留第一个. 清除多余的.
  number = number
    .replace('.', '$#$')
    .replace(/\./g, '')
    .replace('$#$', '.') //只允许输入一个小数点
  return number
}

Vue.prototype.$numberScale2 = (number) => {
  return numberDeal(number).replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入两个小数
}

Vue.prototype.$numberScale3 = (number) => {
  return numberDeal(number).replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3') //只能输入三个小数
}

Vue.prototype.$loadParams = function () {
  var params = localStorage.getItem(this.$route.path)
  if (params) {
    this.query = {
      ...this.query,
      ...JSON.parse(params),
    }
  }
}

Vue.prototype.$storeParams = function () {
  localStorage.setItem(this.$route.path, JSON.stringify(this.query))
}

Vue.prototype.$clearParams = function () {
  localStorage.removeItem('status')
}

Vue.prototype.$downloadTemplate = function (module, category) {
  this.$http
    .get(`/files/${module}/excel/files?category=${category}`)
    .then((res) => {
      let files = res.data
      if (files.length > 0) {
        let file = files.sort((a, b) => {
          return b.uploadDate.localeCompare(a.uploadDate)
        })[0]
        this.$download(`/files/${module}/excel/files/${file.id}`)
      }
    })
}

Vue.prototype.$watchVideo = function (video) {
  let routeUrl = this.$router.resolve({
    path: '/video',
    query: {
      video: video,
    },
  })
  window.open(routeUrl.href, '_blank')
}

function transportModeIdLike(transportModeId, code) {
  return (
    transportModeId != null &&
    transportModeId != '' &&
    transportModeId != undefined &&
    transportModeId.indexOf(code) !== -1
  )
}
Vue.prototype.$isSea = function (transportModeId) {
  return transportModeIdLike(transportModeId, 'SEA')
}

Vue.prototype.$isAir = function (transportModeId) {
  return transportModeIdLike(transportModeId, 'AIR')
}

Vue.prototype.$showError = function (res, errorMsg) {
  if (this.errors[res.response.data.message]) {
    this.$message(
      this.$t('app.messages.errors.title'),
      this.errors[res.response.data.message]
    )
  } else {
    if (errorMsg) {
      this.$message(this.$t('app.messages.errors.title'), errorMsg)
      return
    }
    this.$message(
      this.$t('app.messages.errors.title'),
      this.$t('app.system.error')
    ) //'System Error.'
  }
}

Vue.prototype.$showApiError = function (res) {
  var resultCode = res.data.errorCode || res.data.error
  if (auth[resultCode]) {
    this.$message(this.$t('app.messages.errors.title'), auth[resultCode])
  } else {
    this.$message(
      this.$t('app.messages.errors.title'),
      this.$t('app.system.error')
    ) //'System Error.'
  }
}

// Array.prototype.$groupBy = function(keyName) {
//   var result = {}
//   this.forEach(function(item) {
//     if (!result[item[keyName]]) result[item[keyName]] = new Array()
//     result[item[keyName]].push(item)
//   })
//   return result
// }

//以下函数排序属性并未写死，可直接拿去用自定义属性
Vue.prototype.$sortByProps = function SortByProps(item1, item2, obj) {
  var props = []
  if (obj) {
    props.push(obj)
  }
  var cps = [] // 存储排序属性比较结果。
  // 如果未指定排序属性(即obj不存在)，则按照全属性升序排序。
  // 记录下两个排序项按照各个排序属性进行比较得到的结果
  var asc = true
  if (props.length < 1) {
    for (var p in item1) {
      if (item1[p] > item2[p]) {
        cps.push(1)
        break // 大于时跳出循环。
      } else if (item1[p] === item2[p]) {
        cps.push(0)
      } else {
        cps.push(-1)
        break // 小于时跳出循环。
      }
    }
  } else {
    for (var i = 0; i < props.length; i++) {
      var prop = props[i]
      for (var o in prop) {
        asc = prop[o] === 'ascending'
        if (item1[o] > item2[o]) {
          cps.push(asc ? 1 : -1)
          break // 大于时跳出循环。
        } else if (item1[o] === item2[o]) {
          cps.push(0)
        } else {
          cps.push(asc ? -1 : 1)
          break // 小于时跳出循环。
        }
      }
    }
  }

  // 根据各排序属性比较结果综合判断得出两个比较项的最终大小关系
  for (var j = 0; j < cps.length; j++) {
    if (cps[j] === 1 || cps[j] === -1) {
      return cps[j]
    }
  }
  return false
}
  ; (Vue.prototype.$keydown = function (e) {
    console.log(e)
    var allowKeys = [
      '`',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '0',
      '-',
      '=',
      'q',
      'w',
      'e',
      'r',
      't',
      'y',
      'u',
      'i',
      'o',
      'p',
      '[',
      ']',
      '\\',
      'a',
      's',
      'd',
      'f',
      'g',
      'h',
      'j',
      'k',
      'l',
      ';',
      "'",
      'z',
      'x',
      'c',
      'v',
      'b',
      'n',
      'm',
      ',',
      '.',
      '/',
      '~',
      '!',
      '@',
      '#',
      '$',
      '%',
      '^',
      '&',
      '*',
      '(',
      ')',
      '_',
      '+',
      'Q',
      'W',
      'E',
      'R',
      'T',
      'Y',
      'U',
      'I',
      'O',
      'P',
      '{',
      '}',
      '|',
      'A',
      'S',
      'D',
      'F',
      'G',
      'H',
      'J',
      'K',
      'L',
      ':',
      '"',
      'Z',
      'X',
      'C',
      'V',
      'B',
      'N',
      'M',
      '<',
      '>',
      '?',
      'Backspace',
    ]
    var key = e.key
    if (key === '.' && e.target.value.indexOf(key) > 0) {
      e.preventDefault()
    } else if (allowKeys.indexOf(key) < 0) {
      e.preventDefault()
    }
  }),
    //   var allowKeys = [
    //     '`',
    //     '1','2','3','4','5','6','7','8','9','0','-','=',
    //     'q','w','e','r','t','y','u','i','o','p','[',']','\\',
    //     'a','s','d','f','g','h','j','k','l',';','\'',
    //     'z','x','c','v','b','n','m',',','.','/',
    //     '~','!','@','#','$','%','^','&','*','(',')','_','+',
    //     'Q','W','E','R','T','Y','U','I','O','P','{','}','|',
    //     'A','S','D','F','G','H','J','K','L',':','"',
    //     'Z','X','C','V','B','N','M','<','>','?',
    //     'Backspace'
    // ]

    //键盘上的字符
    (Vue.prototype.$legalInput = function (v) {
      if (!v) {
        return true
      }
      var reg = /^[a-zA-Z\d,.\/\`\~\!\*\-\+\;\'\[\]\\\=\@\#\$\%\^\&\(\)\_\{\}\|\:\"\<\>\?\s]+$/
      var result = reg.test(v)
      return result
    }),
    Vue.directive('exchangeHtml', {
      bind: function (el, foo) {
        console.log(el, foo)
        el.innerHTML += foo.value
      },
    })

Vue.prototype.$getRandomPwd = function randomPassword(length) {
  length = Number(length)
  // Limit length
  if (length < 12) {
    length = 12
  } else if (length > 20) {
    length = 20
  }
  let passwordArray = [
    'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    'abcdefghijklmnopqrstuvwxyz',
    '1234567890',
    '!@#$%^&*()<>?_+-=',
  ]
  var password = []
  let n = 0
  for (let i = 0; i < length; i++) {
    // If password length less than 9, all value random
    if (password.length < length - 3) {
      // Get random passwordArray index
      let arrayRandom = i % 4
      // Get password array value
      let passwordItem = passwordArray[arrayRandom]
      // Get password array value random index
      // Get random real value
      let item = passwordItem[Math.floor(Math.random() * passwordItem.length)]
      password.push(item)
    } else {
      // If password large then 9, lastest 4 password will push in according to the random password index
      // Get the array values sequentially
      let newItem = passwordArray[n]
      let lastItem = newItem[Math.floor(Math.random() * newItem.length)]
      // Get array splice index
      let spliceIndex = Math.floor(Math.random() * password.length)
      password.splice(spliceIndex, 0, lastItem)
      n++
    }
  }
  password = password.sort(function () {
    return Math.random() - 0.5
  })
  return password.join('')
}

function pad(num, n) {
  var len = num.toString().length
  while (len < n) {
    num = '0' + num
    len++
  }
  return num
}

function removeLeftZero(num) {
  return parseInt(num)
}

Vue.prototype.$generateAwbFileName = function (blNo, blDate, attachments) {
  blNo =
    blNo &&
    blNo
      .replaceAll('\\', '')
      .replaceAll('/', '')
      .replaceAll(':', '')
      .replaceAll('*', '')
      .replaceAll('?', '')
      .replaceAll('"', '')
      .replaceAll('<', '')
      .replaceAll('>', '')
      .replaceAll('|', '')
  if (!attachments) {
    attachments = []
  }
  var currentBranches = attachments
    .map((a) => a.name.substr(-7, 3))
    .map((a) => removeLeftZero(a))
  var resultDate = blDate && blDate.replaceAll('-', '')
  for (var i = 0; i < attachments.length + 1; i++) {
    if (currentBranches.indexOf(i) === -1) {
      return blNo + resultDate + pad(i, 3) + '.pdf'
    }
  }
}

Vue.prototype.$today = function () {
  return DateFormat(new Date(), 'yyyy-mm-dd')
}

Vue.prototype.$setEmployee = function () {
  return this.$http.get(`/employees/current`).then((res) => {
    localStorage.setItem('currentEmployee', JSON.stringify(res.data))
  })
}

Vue.prototype.$getEmployee = function () {
  return JSON.parse(localStorage.getItem('currentEmployee'))
}

var ex;

Vue.prototype.$getFileEx = function () {
  console.log(ex)
  ex = new InitUpload({
    accessKeyId: localStorage.getItem('accessKeyId'),
    accessKeySecret: localStorage.getItem('accessKeySecret'),
    bucketName: localStorage.getItem('bucketName'),
    region: localStorage.getItem('region'),
  });
  return ex;
}

Vue.prototype.$downloadTdocFile = function (file) {
  if (!ex) {
    ex = new InitUpload({
      accessKeyId: localStorage.getItem('accessKeyId'),
      accessKeySecret: localStorage.getItem('accessKeySecret'),
      bucketName: localStorage.getItem('bucketName'),
      region: localStorage.getItem('region'),
    });
  }
  return ex.initFileDownloadFn(file.fileOssId).then((res) => {
    console.log(res);
  });
}

Vue.prototype.$downloadFile = function downloadFile(res, filename) {
  const { data, headers } = res
  //const fileName = headers['content-disposition'].replace(/\w+;filename=(.*)/, '$1')
  const blob = new Blob([data], { type: headers['content-type'] })
  console.log(headers)
  const fileLink = document.createElement('a')

  fileLink.href = window.URL.createObjectURL(blob)
  fileLink.setAttribute('download', filename)

  document.body.appendChild(fileLink)

  fileLink.click()
}

Vue.prototype.$checkInOneYear = function checkInOneYear(today, reserveDay) {
  return Math.floor((reserveDay - today) / 1000 / 60 / 60 / 24) < 365
}

Vue.prototype.$daysBetween = function daysBetween(sDate1, sDate2) {
  //Date.parse() 解析一个日期时间字符串，并返回1970/1/1 午夜距离该日期时间的毫秒数
  var time1 = Date.parse(new Date(sDate1))
  var time2 = Date.parse(new Date(sDate2))
  var nDays = Math.abs(parseInt((time2 - time1) / 1000 / 3600 / 24))
  return nDays
}

Vue.prototype.$clearQuery = function clearQuery() {
  this.query = {}
  localStorage.removeItem(this.$route.path)
}

Vue.prototype.$tdocError = (err, result) => {
  console.log(result)
  let $this = this
  if (result) {
    return $this.$t(`tdoc.${err.response.data}`)
  } else {
    return $this.$t('app.system.error')
  }
}
